import { useEffect } from 'react'
import { Button } from './Button'
import styles from './Modal.module.css'

interface ModalProps {
  open: boolean
  title: string
  children: React.ReactNode
  footer?: React.ReactNode
  onClose: () => void
}

export function Modal({ open, title, children, footer, onClose }: ModalProps) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className={styles['overlay']}>
      <div
        className={styles['backdrop']}
        onClick={onClose}
        aria-hidden="true"
      />
      <div className={styles['panel']}>
        <div className={styles['header']}>
          <h2 className={styles['title']}>{title}</h2>
          <Button variant="ghost" size="sm" onClick={onClose} aria-label="Close">
            &times;
          </Button>
        </div>
        <div className={styles['content']}>{children}</div>
        {footer && (
          <div className={styles['footer']}>{footer}</div>
        )}
      </div>
    </div>
  )
}
